import PinCode from './PinCode';

export default PinCode;
